import AbstractValidator from "@/components/CustomForm/Validators/AbstractValidator";
import { CustomFormFieldCreateOrUpdateDto } from "@/api/appService";
import { IValidate } from "@/components/CustomForm/Validators/IValidate";
import ValidatorProperty from "@/components/CustomForm/Validators/ValidatorProperty";

export default class NumberValidator
  extends AbstractValidator
  implements IValidate
{
  constructor(expression: string) {
    super(expression);
  }

  displayName(): string {
    return "数值";
  }

  isMatch(expression: string): boolean {
    return expression === this.name();
  }

  toString(): string {
    return this.name();
  }

  name(): string {
    return "number";
  }

  properties(): ValidatorProperty[] {
    return [];
  }

  validate(value: any): string {
    if (typeof value === "string" && value.length) {
      if (/^([\d]{1,20}(\.\d{1,20})?)$/.test(value)) {
        return "";
      } else {
        return "不是有效的数值";
      }
    } else {
      return "";
    }
  }
}
